var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"az-back-button"},[_c('v-btn',{attrs:{"color":"primary","text":"","depressed":""},on:{"click":_vm.back}},[_c('v-icon',[_vm._v("chevron_left")]),_vm._v(_vm._s(_vm.text)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }